import { render, staticRenderFns } from "./FontSettings.vue?vue&type=template&id=55ac49f0&scoped=true"
import script from "./FontSettings.vue?vue&type=script&lang=js"
export * from "./FontSettings.vue?vue&type=script&lang=js"
import style0 from "./FontSettings.vue?vue&type=style&index=0&id=55ac49f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ac49f0",
  null
  
)

export default component.exports